module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_up-black.eae06bce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyboard_arrow_up-black.svg
// module id = 238
// module chunks = 0